import React, {useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_BottomToolbar, MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {Stack} from "@mui/material";
import Box from "@mui/material/Box";
import ButtonCreate from "../../../../button/ButtonCreate";
import MenuItem from "@mui/material/MenuItem";
import ModalAddJobMetric from "./ModalAddJobMetric";
import JobMetricOrderOrganizationService
    from "../../../../../../API/orders/metric/organization/JobMetricOrderOrganizationService";
import {
    ESTIMATE_GLOBAL_FILTER_FN,
    estimateFilterFns,
    estimateGetColumnCanGlobalFilter,
} from "../../../../../../utils/orders/estimateTableFilter";

const JobMetricOrderOrganizationTable = ({
                                             data,
                                             forModal,
                                             setData,
                                             currency,
                                             currentCurrency,
                                             tableOptions,
                                             tableOptionsHandle,
                                             orderId,
                                             handleModalAlert,
                                             customer
                                         }) => {

    const [modalOpenCreate, setModalOpenCreate] = useState(false);
    const workData = forModal?.filter(el => el.materialOrganizationOption?.typeMaterial !== "PIECE")
    const [loading, setLoading] = useState(false)

    const handleAddJobMetric = () => {
        setModalOpenCreate(true)
    }
    const handleSubmit = (data, handleClose) => {
        setLoading(true)
        JobMetricOrderOrganizationService.save({...data, orderId})
            .then(function (response) {
                setData(prev => [...prev, response.data])
                handleClose()
                handleModalAlert("Данные добавлены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    }
    const sumAmountBasePrice = useMemo(
        () => data.reduce((acc, mEU) => {
            if (mEU.baseWorth !== null) {
                return acc + mEU.baseWorth.price;
            } else {
                return acc;
            }
        }, 0),
        [data]
    );

    const sumAmountAlternativePrice = useMemo(
        () => data.reduce((acc, mEU) => {
            if (mEU.alternativeWorth !== null) {
                return acc + mEU.alternativeWorth.price;
            } else {
                return acc;
            }
        }, 0),
        [data]
    );


    const columns = useMemo(
        () => [
            {
                id: "name",
                header: 'Материал',
                accessorKey: 'materialName',
                enableEditing: false,
                enableGrouping: true,
                minSize: 35,
            },
            {
                id: "metricName",
                header: 'Наименование операции',
                accessorKey: 'metricName',
                enableEditing: false,
                enableGrouping: true,
                minSize: 35,
            },
            {
                id: "unit",
                header: 'Ед.изм.',
                accessorKey: 'unitName',
                enableColumnActions: false,
                enableEditing: false,
                size: 8,
            },
            {
                header: 'Кол',
                accessorKey: 'quantity',
                enableColumnActions: false,
                enableEditing: false,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.toFixed(3)
                },
            },
            {
                header: `Стоимость: ${currency[0].value}`,
                id: 'baseWorth',
                accessorFn: (row) => row.baseWorth?.price,
                enableColumnActions: false,
                enableEditing: false,
                size: 8,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.toFixed(2)
                },
                AggregatedCell: ({cell, table}) => (
                    <>
                        <Box sx={{
                            color: 'secondary.main',
                            fontWeight: 'bold'
                        }}>
                            {cell.getValue()?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2,
                            })}
                        </Box>
                    </>
                ),
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumAmountBasePrice?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2,
                            })} {currency[0].value}
                        </Box>
                    </Stack>
                ),
            },
            {
                header: `Стоимость: ${currency[1].value}`,
                id: 'alternativeWorth',
                accessorFn: (row) => row.alternativeWorth?.price,
                enableColumnActions: false,
                enableEditing: false,
                size: 8,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.toFixed(2)
                },
                AggregatedCell: ({cell, table}) => (
                    <>
                        <Box sx={{
                            color: 'secondary.main',
                            fontWeight: 'bold'
                        }}>
                            {cell.getValue()?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2,
                            })}
                        </Box>
                    </>
                ),
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumAmountAlternativePrice?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2,
                            })} {currency[1].value}
                        </Box>
                    </Stack>
                ),
            }
        ],
        [data, setData],
    );

    const handleDelete = (row) => {
        JobMetricOrderOrganizationService.delete(row.id)
            .then(function () {
                setData(prev => prev.filter(el => el.id !== row.id))
                handleModalAlert("Данные удалены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    };

    const menuItem = [
        {type: "delete", text: "Удалить", handler: handleDelete}
    ]

    return (
        <div>
            {!customer && <Box
                sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px"}}
            >
                <ButtonCreate
                    text={"Добавить работу"}
                    width={190}
                    onClick={handleAddJobMetric}
                />
            </Box>}
            <MaterialReactTable
                renderTopToolbar={({table}) => {
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                    }}>
                        <MRT_ToolbarAlertBanner table={table}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_ToggleFiltersButton table={table}/>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                selectAllMode={"all"}
                muiTableBodyCellProps={{
                    sx: {
                        p: '0px 0px 0px 10px',
                        m: '0px 0px 0px 0px',
                        border: "none",
                        "&:after": {
                            display: "none",
                        },
                        "& td:after": {
                            "&:hover": {
                                backgroundColor: "red"
                            }
                        },
                        "&:not(:last-of-type)": {
                            borderRight: '1px solid #EAEBEA',

                        },
                        "& li": {
                            listStyleType: "none",
                            "& a": {
                                color: "#006CCC",
                                textDecoration: "none",
                                "&:hover": {
                                    textDecoration: "underline"
                                }
                            }
                        }
                    },
                }}
                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem"
                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                "& td:after": {
                                    display: "none",
                                },
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                            '&:nth-of-type(even)': {
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                            },
                        })
                    })
                }}
                muiToolbarAlertBannerProps={{
                    sx: {
                        backgroundColor: (theme) => theme.palette.primary.light,
                    }
                }}

                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: "",
                        size: 10,
                        grow: false,
                    },
                    'mrt-row-select': {
                        size: 10,
                        grow: false,
                    },
                }}
                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: "5px",
                        paddingBottom: "0px",
                        "& .MuiCollapse-root": {
                            borderRadius: '12px',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                columns={columns}
                data={data}
                onPaginationChange={(updater) => {
                    tableOptionsHandle(updater(tableOptions));
                }}
                globalFilterFn={ESTIMATE_GLOBAL_FILTER_FN}
                filterFns={estimateFilterFns}
                getColumnCanGlobalFilter={estimateGetColumnCanGlobalFilter}
                enableGlobalFilterRankedResults={false}
                state={{showGlobalFilter: true, pagination: tableOptions,}}
                paginateExpandedRows={false}
                rowHeight={13}
                columnSpacing={1}
                enableGrouping={true}
                renderBottomToolbar={({table}) => {
                    const tableProps = table.getState().grouping.length > 0
                        ? {
                            ...table,
                            options: {
                                ...table.options,
                                localization: {
                                    ...table.options.localization,
                                    rowsPerPage: `Всего строк: ${data.length}. Сгруппированных элементов на странице:`
                                }
                            }
                        }
                        : table
                    return <MRT_BottomToolbar table={tableProps}/>
                }}
                muiTableContainerProps={{
                    sx: {
                        maxHeight: customer ? `calc(100vh - 400px)` : `calc(100vh - 660px)`,
                    }
                }}

                renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                    return <MenuItem
                        key={el.type}
                        onClick={() => {
                            el.handler(row.original)
                            closeMenu();
                        }}
                        sx={{
                            margin: "0 8px",
                            borderRadius: "4px",
                            "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                        }}
                    >
                        {el.text}
                    </MenuItem>
                })
                }
                enableRowActions={!customer}
                enableToolbarInternalActions={false}
                initialState={{
                    expanded: false,
                    columnVisibility: {
                        id: false,
                    },
                    isFullScreen: false,
                    density: "compact",
                    pagination: {pageIndex: 0, pageSize: 50},
                    grouping: ['name'],
                    sorting: [{id: 'name', desc: false}, {id: 'metricName', desc: false}],
                }}
                getRowId={(originalRow) => originalRow.id}
                localization={MRT_Localization_RU}

            />
            {!customer && <ModalAddJobMetric
                open={modalOpenCreate}
                workData={workData}
                currency={currency}
                onClose={() => setModalOpenCreate(false)}
                handleSubmit={handleSubmit}
                handleModalAlert={handleModalAlert}
                loading={loading}
            />}
        </div>
    );
};

export default JobMetricOrderOrganizationTable;